import cx from 'classnames'
import styles from './styles.module.scss'

interface FeedbackContainerProps {
  error?: string
  success?: string
  position?: 'top' | 'bottom'
  anchorPosition?: 'left' | 'right'
  customClass?: string
}

const FeedbackContainer = ({
  error,
  success,
  position = 'bottom',
  anchorPosition = 'left',
  customClass,
}: FeedbackContainerProps) => (
  <div
    className={cx(
      styles.feedbackContainer,
      {
        [styles.feedbackContainerVisible]: error || success,
      },
      {
        [styles.positionTop]: position === 'top',
        [styles.positionBottom]: position === 'bottom',
      },
      {
        [styles.anchorRight]: anchorPosition === 'right',
      },
      customClass
    )}
  >
    {/* Error */}
    <p className={cx(styles.feedbackText, styles.error)}>{error}</p>

    {/* Success */}
    <p className={cx(styles.feedbackText, styles.success)}>{success}</p>
  </div>
)

export default FeedbackContainer
